import $ from 'jquery';

$('.nav-toggle').on('click', function () {
    var toggleActiveClass = 'nav-toggle--active';
    var navActiveClass = 'navigation--visible';
    if ($(this).hasClass(toggleActiveClass)) {
        $(this).removeClass(toggleActiveClass);
        $('.navigation').removeClass(navActiveClass);
        $('.header').removeClass('header--open-menu');
    } else {
        $(this).addClass(toggleActiveClass);
        $('.navigation').addClass(navActiveClass);
        $('.header').addClass('header--open-menu');

    }

    //force a style recalculation for old safari browsers
    var $listContainer = $(".navigation__list-container");
    setTimeout(function () {
        $listContainer.css('clipPath', 'none');
        $listContainer[0].offsetWidth;
        $listContainer.removeAttr('style');
    },500)
});
